import { SYSTEMS_REGISTRY_SLUG } from '../../api/systemsApi';
import type { MetaRegistryType } from '../../types/systems';

export interface RegistryUiProfile {
  placeholders: {
    code: string;
    name: string;
    description: string;
  };
  features: {
    infrastructureBinding: boolean;
    infrastructureDetails: boolean;
    bcCapabilityBinding: boolean;
  };
}

export const DEFAULT_REGISTRY_UI_PROFILE: RegistryUiProfile = {
  placeholders: {
    code: 'entry-code',
    name: 'Новая запись',
    description: 'Краткое описание',
  },
  features: {
    infrastructureBinding: false,
    infrastructureDetails: false,
    bcCapabilityBinding: false,
  },
};

export function resolveRegistryUiProfile(registryType?: MetaRegistryType | null): RegistryUiProfile {
  const schema = registryType?.attr_schema ?? {};
  const uiProfile = schema.ui_profile ?? {};
  const entryForm = uiProfile.entry_form ?? {};
  const detailsPanel = uiProfile.details_panel ?? {};
  const legacySystemsFallback = registryType?.slug === SYSTEMS_REGISTRY_SLUG;

  return {
    placeholders: {
      code: entryForm.code_placeholder ?? (legacySystemsFallback ? 'my-system-code' : DEFAULT_REGISTRY_UI_PROFILE.placeholders.code),
      name: entryForm.name_placeholder ?? (legacySystemsFallback ? 'Моя система' : DEFAULT_REGISTRY_UI_PROFILE.placeholders.name),
      description: entryForm.description_placeholder ?? DEFAULT_REGISTRY_UI_PROFILE.placeholders.description,
    },
    features: {
      infrastructureBinding: entryForm.show_infrastructure_binding ?? legacySystemsFallback ?? false,
      infrastructureDetails: detailsPanel.show_infrastructure ?? legacySystemsFallback ?? false,
      bcCapabilityBinding: entryForm.show_bc_capability_binding ?? legacySystemsFallback ?? false,
    },
  };
}
